export const everyday = {
  color: "yellow-c-everyday",
  hex: "#FEC97F",
};
